import { createStore } from 'redux'
import rootReducer from './rootReducers'

// preloadedState will be passed in by the plugin
const createAppStore = preloadedState => {
  return createStore(rootReducer, preloadedState)
}

export default createAppStore
